import { useQuery } from '@tanstack/react-query'
import { aiApi } from '@/api/ai'

/**
 * Real ai-engine usage/audit data (ai-engine/app/routers/verification.py) — manager+ only.
 * Unlike lib/ops.ts's AiChat/ServiceHealthGrid (this package's pre-existing, separately
 * broken `/agent` proxy path, see AI_OPS_INTEGRATION.md), this uses the correct working
 * pattern: shared-core's `aiApi` + bearer-token-authenticated `http` client through the
 * gateway's real `/ai/{**catch-all}` route.
 */

export const aiUsageQueryKeys = {
  usageStats: ['ai', 'usage-stats'] as const,
  auditLogs: (limit: number) => ['ai', 'audit-logs', limit] as const,
}

export function useAiUsageStats() {
  return useQuery({
    queryKey: aiUsageQueryKeys.usageStats,
    queryFn: () => aiApi.getUsageStats(),
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}

export function useAiAuditLogs(limit = 20) {
  return useQuery({
    queryKey: aiUsageQueryKeys.auditLogs(limit),
    queryFn: () => aiApi.getAuditLogs(limit),
    staleTime: 15_000,
  })
}
